module.exports = __webpack_public_path__ + "static/media/Payments.15852cc1.svg";